export class ArrayHelper {
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	static groupBy(array: Array<any>, func: (t) => any): Array<any> {
		// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
		return this.groupByTyped<any>(array, func);
	}

	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	static groupByTyped<T>(array: Array<T>, func: (t) => any): Array<Array<T>> {
		let oArray = array.slice();
		let rArray: Array<Array<T>> = [];
		if (oArray.length > 0) {
			while (oArray.length > 0) {
				// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
				let cArray: Array<any> = [];
				let dr = func(oArray[0]);
				for (let i: number = oArray.length - 1; i >= 0; i--) {
					if (func(oArray[i]) === dr) {
						cArray.push(oArray[i]);
						oArray.splice(i, 1);
					}
				}
				rArray.push(cArray.reverse());
			}
		}
		return rArray;
	}

	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	static groupByToKey(array: Array<any>, func: (t) => string): { [key: string]: Array<any> } {
		// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
		let rArray: { [key: string]: Array<any> } = {};
		for (let k in array) {
			if (!Object.hasOwn(array, k)) continue;

			let dr = func(array[k]);
			if (typeof rArray[dr] === 'undefined') rArray[dr] = [];

			rArray[dr].push(array[k]);
		}
		return rArray;
	}
}

Array.groupBy = (array, func) => ArrayHelper.groupBy(array, func);
Array.groupByToKey = (array, func) => ArrayHelper.groupByToKey(array, func);
